import {
  Admin,
  Bank,
  Businesses,
  GroupNetwork,
  Inspection,
  Inventory,
  ManufactureManagement,
  Manufacturer,
  MusharkaContract,
  Notepad,
  OwnedAssets,
  Profile,
  Request,
  Requests,
  Settings,
  Transaction,
} from "../shared/icon";

export const adminSidebarMenu = {
  ADMIN: [
    {
      label: "businesses",
      icon: <Businesses />,
      path: "/businesses",
    },
    {
      label: "sub-admins",
      icon: <Admin />,
      path: "/sub-admins",
    },
    {
      label: "transactions",
      icon: <Transaction />,
      path: "/transactions",
    },
    {
      label: "purchase-requests",
      icon: <Request />,
      path: "/purchase-requests",
    },
    {
      label: "bank-transfer-requests",
      icon: <Bank />,
      path: "/bank-transfer-requests",
    },
    {
      label: "metals-pools",
      icon: <GroupNetwork />,
      path: "/metals-stones-pools",
    },
    {
      label: "musharka-contracts",
      icon: <MusharkaContract />,
      path: "/musharka-contracts",
    },
    {
      label: "manufacturer-requests",
      icon: <ManufactureManagement />,
      path: "/manufacturer",
    },
    { label: "owned-assets", icon: <OwnedAssets />, path: "/owned-assets" },
    {
      label: "subscription-plans",
      icon: <Notepad />,
      path: "/subscription-plans",
    },
    {
      label: "settings",
      icon: <Settings />,
      path: "/settings/general-settings",
      list: [
        { label: "general-settings", path: "/settings/general-settings" },
        { label: "tax-settings", path: "/settings/tax-settings" },
        {
          label: "metal-stone-setting",
          path: "/settings/metal-stone-settings",
        },
        {
          label: "selectable-field-settings",
          path: "/settings/selectable-field-settings",
        },
        { label: "bank-settings", path: "/settings/bank-setting" },
      ],
    },
  ],
  TAQABETH_ENFORCER: [
    {
      label: "request-management",
      icon: <Requests />,
      path: "/request-management",
    },
    {
      label: "stock-management",
      icon: <Inventory />,
      path: "/stock-management",
    },
    {
      label: "profile",
      icon: <Profile />,
      path: "/profile",
    },
  ],
  JEWELLERY_INSPECTOR: [
    {
      label: "inspection-requests",
      icon: <Inspection />,
      path: "/inspection-requests",
    },
    {
      label: "manufacturing-requests",
      icon: <Manufacturer />,
      path: "/manufacturing-requests",
    },
    {
      label: "profile",
      icon: <Profile />,
      path: "/profiles",
    },
  ],
  JEWELLERY_BUYER: [
    {
      label: "stock-management",
      icon: <Inventory />,
      path: "/stocks-management",
    },
    {
      label: "product-requests",
      icon: <Requests />,
      path: "/product-requests",
    },
    {
      label: "delivery-requests",
      icon: <Request />,
      path: "/delivery-requests",
    },
    {
      label: "profile",
      icon: <Profile />,
      path: "/profile-management",
    },
  ],
};

export const userSidebarMenu = {
  INVESTOR: [
    {
      label: "settings",
      path: "/settings",
    },
  ],
  MANUFACTURER: [
    {
      label: "settings",
      path: "/settings",
    },
  ],
  JEWELER: [
    {
      label: "settings",
      path: "/settings",
    },
  ],
  SELLER: [
    {
      label: "settings",
      path: "/settings",
    },
  ],
};
